// extracted by css-extract-rspack-plugin
export default {"cls1":"index-cls1_8ji","cls2":"index-cls2_0Wh index-cls1_8ji"};